import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,
} from "react-router-dom";

const loadingStyle = {
    zIndex: "3000",
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: "0",
    left: "0",
};

export default class Loading extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount = () => {};

    componentWillUnmount = () => {};

    render() {
        return (
            <div className="overlay-wrapper">
                <div className="overlay" style={loadingStyle}>
                    <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                </div>
            </div>
        );
    }
}
